import React from "react";


function Hero({ onJoinClick }) {
  return (
    <section className="hero">
      
        <div className="container hero-inner">
        <div className="hero-text">
          <h1 className="no-wrap">Beyond Badminton Central Coast</h1>
          <p className="hero-subtitle">Where passion meets precision.</p>
          <div className="hero-actions">
            <button className="btn btn-primary" onClick={onJoinClick}>
              Join Us
            </button>
            <button className="btn btn-outline" onClick={onJoinClick}>
              Membership Info
            </button>
          </div>
        </div>
        <div className="hero-side">
          <p className="hero-tagline">
            A community‑focused, not‑for‑profit badminton club for all ages and skill levels.
          </p>
        </div>
      </div>
      
    </section>
  );
}

export default Hero;
